// MVA og eiendeler (no).
window.PlummeI18n.register('no', {
  // ------------------------------------------------------- MVA-melding (vat)
  'vat.term': 'MVA-termin',
  'vat.termHelp': 'En MVA-termin er en periode du rapporterer merverdiavgift for. De fleste leverer annenhver måned - 6 terminer i året. For hver termin summeres utgående og inngående MVA, og differansen betales til eller fås igjen fra staten.',
  'vat.termShort': 'termin',
  'vat.deadline': 'FRIST',
  'vat.amountHelp': 'MVA å betale betyr at du skylder staten fordi utgående MVA var større enn inngående MVA. MVA til gode betyr at du får penger igjen fordi du har betalt mer MVA på kjøp enn du krevde inn på salg.',
  'vat.openReturn': 'Åpne melding',
  'vat.sortHelp': 'Terminene er sortert etter status: Krever handling må leveres nå, Kommende er fremtidige perioder, og Tidligere er allerede levert eller betalt.',
  'vat.noTerms': 'Ingen MVA-terminer ennå',
  'vat.incompleteBasisTitle': 'MVA-grunnlaget er ufullstendig',
  'vat.incompleteBasisText': 'MVA-meldingen vises ikke som komplett fordi journaldekningen ikke er dokumentert. Dokumentberegninger kan fortsatt brukes diagnostisk, men ikke som komplett regnskapsgrunnlag.',
  'vat.needsAction': 'Krever handling',
  'vat.upcoming': 'Kommende',
  'vat.earlier': 'Tidligere',
  'vat.toPay': 'MVA å betale',
  'vat.toPayHelp': 'Samlet utestående MVA der utgående MVA er større enn inngående MVA.',
  'vat.paidIn': 'Innbetalt',
  'vat.paidInHelp': 'MVA-betalinger du har registrert mot terminer i Plumme.',
  'vat.refunded': 'Tilbakebetalt',
  'vat.refundedHelp': 'MVA-tilbakebetalinger du har registrert mot terminer i Plumme.',
  'vat.perTerm': 'Per termin',
  'vat.returnStatus': 'Status for MVA-melding',
  'vat.period': 'Periode',
  'vat.due': 'Frist',
  'vat.calculated': 'Beregnet oppgjør',
  'vat.settlement': 'Oppgjør',
  'vat.cancelPayment': 'Annuller betaling',
  'vat.date': 'Dato',
  'vat.amount': 'Beløp',
  'vat.reference': 'Referanse',
  'vat.referencePh': 'F.eks. nettbank, OCR',
  'vat.payments': 'Betalinger',
  'vat.paymentsHelp': 'Oversikt over betalinger registrert mot denne MVA-terminen.',
  'vat.noPayments': 'Ingen betalinger registrert',
  'vat.fromAccount': 'Fra konto',
  'vat.edit': 'Rediger',
  'vat.cancel': 'Annuller',
  'vat.cancelPaymentTitle': 'Annuller betaling?',
  'vat.cancelPaymentConfirm': 'Ja, annuller betaling',
  'vat.backToTerms': 'Tilbake til terminer',
  'vat.importedBasisTitle': 'Importert fra annet regnskapssystem',
  'vat.importedBasisHelp': 'Tallene er importert som grunnlag. Du kan opprette, sende inn og ved behov annullere MVA-meldingen med den vanlige flyten.',
  'vat.outputVat': 'Utgående MVA',
  'vat.outputVatHelp': 'MVA du har krevd inn på salget i terminen.',
  'vat.inputVat': 'Inngående MVA',
  'vat.inputVatHelp': 'Fradragsberettiget MVA du har betalt på kjøp i terminen.',
  'vat.netVat': 'Netto MVA',
  'vat.netHelp': 'Utgående minus inngående MVA. Positivt beløp betales, negativt beløp er til gode.',
  'vat.checkStatus': 'Sjekk status',
  'vat.checkStatusHelp': 'Vis Plummes lagrede status for mva-meldingen. Automatisk status fra Altinn eller Skatteetaten er ikke koblet i denne Plumme-flaten ennå.',
  'vat.seePayment': 'Se betaling',
  'vat.seePaymentHelp': 'Se betalingene som er registrert mot denne MVA-terminen — dato, konto, beløp og referanse.',
  'vat.codeOverview': 'Kodeoversikt for innsending',
  'vat.codeOverviewHelp': 'MVA-meldingen bygges av standardiserte MVA-koder fra Skatteetaten. Hver kode samler et bestemt slags salg eller kjøp. Grunnlaget er beløpet uten MVA. Ved omvendt avgiftsplikt vises både utgående og inngående MVA, selv når nettoen er 0. Trykk på en kode for å se hva som hører hjemme der.',
  'vat.codeTapHint': 'Trykk på en kode for å se hva som hører hjemme der.',
  'vat.code': 'Kode',
  'vat.description': 'Beskrivelse',
  'vat.basis': 'Grunnlag',
  'vat.rate': 'Sats',
  'vat.vat': 'MVA',
  'vat.calculatedFrom': 'Beregnet fra det du har registrert i appen',
  'vat.delete': 'Slett',
  'vat.annulCustoms': 'Annuler',
  'vat.annulled': 'Annullert',
  'vat.showAnnulledCustoms': 'Vis annullerte',
  'vat.showActiveCustoms': 'Vis aktive',
  'vat.customsAnnulled': 'Tolldeklarasjon annullert',
  'vat.customsAnnulFailed': 'Kunne ikke annullere tolldeklarasjonen.',
  'vat.registerCustoms': 'Registrer tolldeklarasjon',
  'vat.customsHelp': 'Legg inn en tolldeklarasjon for varer du har innført fra utlandet. Plumme regner ut innførsels-MVA fra statistisk verdi og legger den inn på riktig kode i meldingen.',
  'vat.flowHelp': 'Kontroller tallene fra de bokførte bilagene. Plumme kan ikke sende MVA-meldingen: du leverer den i Skatteetatens tjeneste og markerer deretter terminen som levert utenfor Plumme her. Da kan du registrere betalingen. Levert-status kan fjernes igjen hvis den ble satt ved en feil.',
  'vat.filing.statusFiled': 'Levert utenfor Plumme',
  'vat.filing.statusFiledPaid': 'Levert utenfor Plumme og betalt',
  'vat.filing.statusNotFiled': 'Ikke markert som levert',
  'vat.filing.reviewFigures': 'Kontroller tallene',
  'vat.filing.reviewedToast': 'Tallene er kontrollert. Lever MVA-meldingen hos Skatteetaten.',
  'vat.filing.markOutside': 'Marker som levert utenfor Plumme',
  'vat.filing.clearStatus': 'Fjern levert-status',
  'vat.filing.dialogTitle': 'Lever MVA-meldingen hos Skatteetaten',
  'vat.filing.cannotSend': 'Plumme kan ikke sende eller signere MVA-meldingen. Du leverer den selv hos Skatteetaten, og markerer terminen som levert her etterpå.',
  'vat.filing.step1': 'Åpne MVA-meldingen i Skatteetatens tjeneste og før inn tallene for denne terminen fra Plumme.',
  'vat.filing.step2': 'Send inn og signer meldingen der, og ta vare på kvitteringen.',
  'vat.filing.step3': 'Marker terminen som levert utenfor Plumme her. Da kan du registrere betalingen, og terminen teller som levert i årsavslutningen.',
  'vat.filing.termNotEnded': 'Terminen er ikke over ennå. MVA-meldingen kan først leveres etter at terminen er slutt.',
  'vat.filing.filedDate': 'Levert dato',
  'vat.filing.reference': 'Referanse (valgfritt)',
  'vat.filing.referencePh': 'For eksempel referansen på kvitteringen fra Skatteetaten',
  'vat.filing.comment': 'Kommentar (valgfritt)',
  'vat.filing.lockNote': 'Når terminen er markert som levert, låses bilagene i perioden. Endringer må da gjøres som en korrigering.',
  'vat.filing.clearText': 'Terminen står da som ikke levert i Plumme, og bilagene i perioden låses opp igjen. Endringen logges med hvem og når. Status hos Skatteetaten endres ikke.',
  'vat.filing.clearReason': 'Begrunnelse (valgfritt)',
  'vat.filing.markedToast': 'Terminen er markert som levert utenfor Plumme',
  'vat.filing.clearedToast': 'Levert-status er fjernet',
  'vat.filing.failed': 'Kunne ikke oppdatere MVA-status.',
  'vat.filing.payAfterFiled': 'Tilgjengelig når MVA-meldingen er levert hos Skatteetaten og markert som levert her.',
  'vat.filing.markedOn': 'Markert i Plumme',
  'vat.filing.referenceLabel': 'Referanse',
  'vat.filing.commentLabel': 'Kommentar',
  'vat.filing.statusNote': 'Plumme henter ikke status fra Skatteetaten. Statusen her er det som er markert i Plumme.',
  'vat.addComment': 'Legg til kommentar',
  'vat.customs': 'Tolldeklarasjon',
  'vat.correctCustoms': 'Korriger tolldeklarasjon',
  'vat.saveCustoms': 'Lagre tolldeklarasjon',
  'vat.fetchFromAltinn': 'Hent fra Altinn',
  'vat.fetchFromAltinnHelp': 'Fyll inn referanse og tollgrunnlag automatisk fra innsendte deklarasjoner.',
  'vat.declarationRef': 'Deklarasjonsreferanse',
  'vat.declarationRefPh': 'Referanse fra tollvesenet',
  'vat.statisticalValue': 'Statistisk verdi',
  'vat.vatCode': 'MVA-kode',
  'vat.attachments': 'Vedlegg / importspor',
  'vat.uploadAttachment': 'Last opp vedlegg',
  'vat.attachmentHelp': 'Valgfritt, men anbefalt for revisjonsspor og senere importoppfølging.',
  'vat.customsBasis': 'Tollgrunnlag',
  'vat.calculatedVat': 'Beregnet MVA',
  'vat.deductible': 'Fradragsrett',
  'vat.settlementDate': 'Oppgjørsdato',
  'vat.settlementType': 'Type oppgjør',
  'vat.useDueDate': 'Forfallsdato',
  'vat.useDueDateHelp': 'Sett oppgjørsdatoen til forfallsdatoen for MVA-meldingen',
  'vat.addSurcharges': 'Legg til renter/gebyr',
  'vat.surcharges': 'Renter og gebyr',
  'vat.removeSurcharges': 'Fjern',
  'vat.lateInterest': 'Forsinkelsesrente',
  'vat.lateInterestHelp': 'Føres som rentekostnad på 8150',
  'vat.penaltyFee': 'Gebyr eller tvangsmulkt',
  'vat.penaltyFeeHelp': 'Føres på 7799 og er ikke fradragsberettiget',
  'vat.surchargeTotal': 'Trekkes fra kontoen',
  'vat.surchargeNote': 'Renter og gebyr er ikke merverdiavgift. De kostnadsføres og trekkes fra kontoen, men endrer ikke MVA-oppgjøret for terminen.',
  'vat.kid': 'KID',
  'vat.payTitle': 'Betal MVA til Skatteetaten',
  'vat.payHelp': 'Kontonummer og KID kommer fra Skatteetaten når meldingen er behandlet. Betaling rett fra banken er ikke koblet på ennå, så betalingen registreres i Plumme inntil videre.',
  'vat.awaitingAuthority': 'Kommer fra Skatteetaten',
  'vat.pay': 'Betal',
  'vat.kidHelp': 'KID fra MVA-meldingen',
  'vat.authorityAccount': 'Kontonummer til Skatteetaten',
  'vat.authorityAccountHelp': 'Skatteetatens kontonummer',
  'vat.notRegistered': 'Foretaket er ikke satt som MVA-registrert',
  'vat.view': 'Visning',
  'vat.viewHelp': 'Bytt mellom «Terminer» — et kort per MVA-periode med status og frist — og «Oversikt», som oppsummerer hva du skylder, har betalt og har til gode på tvers av terminene.',
  'vat.viewTerms': 'Terminer',
  'vat.viewOverview': 'Oversikt',

  'vat.filing.notFiled': 'Ikke levert',
  'vat.filing.upcomingStatus': 'Kommende',
  'vat.filing.importedArchive': 'Importert arkiv',
  'vat.vatReceivable': 'MVA til gode',
  'vat.vatToPay': 'MVA å betale',
  'vat.noVat': 'Ingen MVA',
  'vat.noneWithWord': 'Ingen {{word}}',
  'vat.manualUnsupported': '{{word}} på fri postering er ikke aktivert for {{country}} ennå',
  'vat.manual.input25': '1 - Inngående MVA 25 %',
  'vat.manual.input15': '11 - Inngående MVA 15 %',
  'vat.manual.input12': '13 - Inngående MVA 12 %',
  'vat.manual.output25': '3 - Utgående MVA 25 %',
  'vat.manual.output15': '31 - Utgående MVA 15 %',
  'vat.manual.output12': '33 - Utgående MVA 12 %',
  'vat.manual.reverseGoods25': '81 - Snudd avgift varer 25 %',
  'vat.manual.reverseServices25': '86 - Snudd avgift tjenester 25 %',
  'vat.manual.importVatOnly25': '14 - Kun inngående MVA 25 %',
  'vat.manual.importBasis25': '21 - Grunnlag ved innførsel 25 %',
  'vat.manual.importBasisZero': '23 - Grunnlag ved innførsel uten MVA (SAF-T 20)',
  'vat.receivableShort': 'Til gode',
  'vat.remainingToPay': 'Gjenstår å betale',
  'vat.termLabel': '{n}. termin {year}',
  'vat.noTermsHelp': 'Når foretaket er MVA-registrert, viser Plumme terminer, frister og beregnet MVA her.',
  'vat.youOwe': 'Du skylder',
  'vat.youAreOwed': 'Du har til gode',
  'vat.noVatToSettle': 'Ingen MVA å gjøre opp',
  'vat.refund': 'Tilbakebetaling',
  'vat.paymentNoun': 'Betaling',
  'vat.settlementNoun': 'Oppgjør',
  'vat.acctBankDeposit': 'Bankinnskudd',
  'vat.acctTaxDeductionAccount': 'Skattetrekkskonto',
  'vat.acctCash': 'Kontanter',
  'vat.accountFallback': '{code} Konto',
  'vat.settlementFullyRegistered': 'Fullt registrert',
  'vat.settlementPartiallyRegistered': 'Delvis registrert',
  'vat.settlementNotRegistered': 'Ikke registrert',
  'vat.editRefund': 'Rediger tilbakebetaling',
  'vat.editPayment': 'Rediger betaling',
  'vat.receivedOn': 'Mottatt på',
  'vat.paidFrom': 'Betalt fra',
  'vat.noPaymentsHelp': 'Når du registrerer betaling eller tilbakebetaling for terminen, vises den her.',
  'vat.addRefund': 'Legg til tilbakebetaling',
  'vat.addPayment': 'Legg til betaling',
  'vat.cancelPaymentConfirmPrefix': 'Vil du annullere {kind} på',
  'vat.cancelPaymentConfirmDate': ' registrert {date}',
  'vat.cancelPaymentConfirmSuffix': '? Beløpet fjernes fra MVA-terminen og kan ikke hentes tilbake.',
  'vat.overpaid': 'Betalt for mye',
  'vat.overrefunded': 'Fått tilbake for mye',
  'vat.remainingToReceive': 'Gjenstår å få tilbake',
  'vat.registerSettlement': 'Registrer oppgjør',
  'vat.registerPayment': 'Registrer betaling',
  'vat.registerRefund': 'Registrer tilbakebetaling',
  'vat.inYourFavor': 'i din favør',
  'vat.toTaxAuthority': 'til Skatteetaten',
  'vat.receivedBack': 'Fått tilbake',
  'vat.archiveCannotSettle': 'Importert historikk kan ikke gjøres opp som en ny Plumme-termin.',
  'vat.noVatToSettleForTerm': 'Terminen har ingen MVA å gjøre opp.',
  'vat.sourceImported': 'Importert',
  'vat.sourceManual': 'Registrert manuelt',
  'vat.registerVatRefund': 'Registrer MVA-tilbakebetaling',
  'vat.registerVatPayment': 'Registrer MVA-betaling',
  'vat.saveRefund': 'Lagre tilbakebetaling',
  'vat.savePayment': 'Lagre betaling',
  'vat.remainingHint': 'Gjenstår {amount}',
  'vat.notRegisteredHelp': 'Når foretaket blir MVA-registrert i innstillingene, viser Plumme MVA-terminer, kodeoversikt og oppgjør her.',
  'vat.reviewReadyToast': 'MVA-meldingen er klargjort for kontroll',
  'vat.customsAltinnNotConnected': 'Altinn-import for tolldeklarasjoner er ikke koblet ennå.',
  'vat.selectAttachmentToUpload': 'Velg et vedlegg å laste opp',
  'vat.customsDefaultDescription': 'Tolldeklarasjon',
  'vat.customsDateTermHint': 'Datoen må være innenfor {period}.',
  'vat.customs81': '25 % med fradragsrett',
  'vat.customs82': '25 % uten fradragsrett',
  'vat.customs83': '15 % med fradragsrett',
  'vat.customs84': '15 % uten fradragsrett',
  'vat.customs85': '0 % innførsel',
  'vat.customsSaved': 'Tolldeklarasjon lagret',
  'vat.customsSaveFailed': 'Kunne ikke lagre tolldeklarasjonen.',
  'vat.customsDeleted': 'Tolldeklarasjon slettet',
  'vat.customsDeleteFailed': 'Kunne ikke slette tolldeklarasjonen.',
  'vat.refundSaved': 'Tilbakebetaling lagret',
  'vat.paymentSaved': 'Betaling lagret',
  'vat.paymentSaveFailed': 'Kunne ikke lagre betalingen.',
  'vat.refundCancelled': 'Tilbakebetaling annullert',
  'vat.paymentCancelled': 'Betaling annullert',
  'vat.paymentCancelFailed': 'Kunne ikke annullere betalingen.',

  // Leverandørvelger (delt med kjøpsflyten)
  'vat.supplierSearch': 'Søk eller legg til leverandør...',
  'vat.supplierClose': 'Lukk leverandørvalg',
  'vat.supplierNone': 'Ingen leverandører funnet.',
  'vat.supplierNew': 'Ny leverandør',
  'vat.supplierName': 'Navn',
  'vat.supplierOrg': 'Org.nr.',
  'vat.supplierEmail': 'E-post',
  'vat.supplierPhone': 'Telefon',

  // ------------------------------------------------------------- Eiendeler
  // ---------------------------------------- Fixed assets: register, editor, detail

  'vat.customsPostingExplanation': 'Bruk tallene fra tolldeklarasjonen. MVA uten fradragsrett må føres på riktig kostnads- eller eiendelskonto.',
  'vat.nonDeductibleAccount': 'Konto for MVA uten fradragsrett',
  'vat.nonDeductibleAccountHelp': 'Velg samme kostnads- eller eiendelskonto som anskaffelsen gjelder. Konto må oppgis før bokføring.',

  // --------------------------------------- Transactions list, inbox status, paid-purchase flow
  'voucherList.titleHelp': 'Et bilag er dokumentasjonen bak en bokføring: faktura, kvittering, annet salg, tolldeklarasjon eller fri postering. Her ser du bilagene som er hentet fra backend for valgt regnskapsår.',
  'voucherList.backToTrialBalance': 'Tilbake til saldobalansen',
  'voucherList.backToIncomeStatement': 'Tilbake til resultatregnskapet',
  'voucherList.accountBadge': 'Konto {number} · {name}',
  'voucherList.vatCodeBadge': 'MVA-kode {code}',
  'voucherList.viewOptions': 'Visningsvalg',
  'voucherList.noneForVatCode': 'Ingen bilag funnet for MVA-kode {code} i valgt periode.',
  'voucherList.noneForAccount': 'Ingen bilag ført på {number} {name} i {year}.',
  'voucherList.noneMatchSearch': 'Ingen bilag matcher søket.',
  'voucherList.noneInView': 'Ingen bilag matcher visningen.',
  'voucherList.ledgerLinesMissing': 'Bilagene mangler bokføringslinjer fra backend.',
  'voucherList.debit': 'Debet',
  'voucherList.credit': 'Kredit',
  'voucherList.colVoucher': 'Bilag',
  'voucherList.colNumber': 'Bilagsnr.',
  'voucherList.colDate': 'Dato',
  'voucherList.inlineVat': 'MVA',
  'voucherList.kindInvoice': 'Faktura',
  'voucherList.kindSupplier': 'Leverandør',
  'voucherList.kindCreditNote': 'Kreditnota',
  'voucherList.kindManual': 'Manuelt bilag',
  'voucherList.kindPurchase': 'Kjøp',
  'voucherList.kindOtherSale': 'Annet salg',
  'voucherList.kindMileage': 'Kjørebok',
  'voucherList.kindCustoms': 'Tolldeklarasjon',
  'voucherList.kindCustomsCorrection': 'Periodekorrigering av tolldeklarasjon',
  'voucherList.kindBankPosting': 'Bankpostering',
  'voucherList.kindPayment': 'Betaling',
  'voucherList.kindPayroll': 'Lønn',
  'voucherList.kindPayrollPayment': 'Lønnsbetaling',
  'voucherList.kindReversal': 'Reversering',
  'voucherList.kindPublicFees': 'Offentlige avgifter',
  'voucherList.kindAssetDisposal': 'Avgang driftsmiddel',
  'voucherList.kindYearEnd': 'Årsoppgjør',
  'voucherList.kindQuote': 'Tilbud',
  'voucherList.kindOrderConfirmation': 'Ordrebekreftelse',
  'voucherList.filterSales': 'Salg',
  'voucherList.filterSupplierInvoice': 'Leverandørfaktura',
  'voucherList.filterFreePosting': 'Fri postering',
  'voucherList.missingAttachment': 'Mangler vedlegg',
  'voucherList.hasAttachment': 'Har vedlegg',
  'voucherList.unpaid': 'Ubetalt',
  'voucherList.showAnnulled': 'Vis annullerte',
  'voucherList.hidePayments': 'Ikke vis betaling',
  'voucherList.includeAnnulled': 'Vis annullerte',
  'vat.amountOnly': 'Ren MVA',
  'voucherList.onlyAnnulled': 'Vis kun annullerte',
  'voucherList.paid': 'Betalt',
  'voucherList.partiallyPaid': 'Delbetalt',
  'voucherList.annulled': 'Annullert',
  'voucherList.attachmentLost': 'Bilag borte',
  'voucherList.openInvoiceList': 'Se i fakturaliste',
  'voucherList.editSale': 'Rediger salg',
  'voucherList.openInBank': 'Åpne i bank',
  'voucherList.editPosting': 'Rediger postering',
  'voucherList.correctPosting': 'Korriger bilag',
  'voucherList.editMileage': 'Rediger kjørebok',
  'voucherList.openInVat': 'Åpne i MVA',
  'voucherList.edit': 'Rediger',
  'voucherList.purchaseNotFound': 'Fant ikke kjøpet som skal redigeres. Prøv å oppdatere siden og åpne bilaget på nytt.',
  'voucherList.saleNotFound': 'Fant ikke salget som skal redigeres. Prøv å oppdatere siden og åpne bilaget på nytt.',
  'inboxStatus.alreadyBooked': 'Allerede bokført?',
  'inboxStatus.booked': 'Bokført',
  'inboxStatus.inTrash': 'I papirkurv',
  'inboxStatus.readyToBook': 'Klar for bokføring',
  'inboxStatus.needsReview': 'Trenger kontroll',
  'inboxStatus.analysisFailed': 'Analyse feilet',
  'inboxStatus.analyzing': 'Analyseres',
  'inboxStatus.awaitingAnalysis': 'Venter på analyse',
  'inboxStatus.show': 'Vis',
  'inboxStatus.hide': 'Skjul',
  'inboxStatus.dropReceipts': 'Slipp bilagene her',
  'inboxStatus.dropReceiptsHint': 'SuperPlumma leser av det vi kan',
  'inboxStatus.dropDocuments': 'Slipp dokumentene her',
  'inboxStatus.dropDocumentsHint': 'Legges i Dokumentasjon',
  'inboxStatus.bookWithSuperPlumma': 'Bokfør med SuperPlumma',
  'inboxStatus.saving': 'Lagrer...',
  'purchaseFlow.stepReceipt': 'Bilag',
  'purchaseFlow.stepDetails': 'Detaljer',
  'purchaseFlow.stepLines': 'Linjer',
  'purchaseFlow.stepPreview': 'Forhåndsvisning',
  'purchaseFlow.typeRegular': 'Betalt kjøp',
  'purchaseFlow.typeInvoice': 'Leverandørfaktura',
  'purchaseFlow.typeDrafts': 'Utkast',
  'purchaseFlow.receivedReading': 'Bilag mottatt - SuperPlumma leser det nå',
  'purchaseFlow.receivedReadingMany': '{count} bilag mottatt - SuperPlumma leser dem nå',
  'purchaseFlow.prefilled': 'SuperPlumma fylte inn det som kunne leses fra bilaget. Kontroller før du bokfører.',
  'purchaseFlow.amountReview': 'Beløp og MVA kunne ikke fylles inn sikkert. Kontroller bilaget og legg inn nettobeløp og riktig MVA-behandling per linje før du bokfører.',
  'purchaseFlow.analysisFailed': 'Bilaget ble lastet opp, men analysen feilet.',
  'purchaseFlow.inboxResolveFailed': 'Føringen er lagret, men bilaget ble ikke fjernet fra innboksen. Merk det som bokført der.',
  'purchaseFlow.receiptFallbackName': 'Bilag',
});
